import React from "react";

interface ContactUsSlidderCardProps {
  stars: number;
  text: string;
}

const ContactUsSlidderCard: React.FC<ContactUsSlidderCardProps> = ({
  stars,
  text,
}) => {
  return (
    <div className="contact-us-card">
      <div className="contact-us-card-stars">{"★".repeat(stars)}</div>
      <p className="contact-us-card-text">"{text}"</p>
    </div>
  );
};

export default ContactUsSlidderCard;
